export default "__VITE_ASSET__Bh$53chH__"